// FormularioRepresentante.jsx
import React from 'react';
import { Typography, FormControl, TextField } from '@mui/material';
import Grid from "@mui/material/Grid2";
import { validarRut, formatearRut } from '../utils/utilsRut';
import {toSnakeCase} from "../utils/general_utils";

/**
 * editableRutNombre: habilita Nombre y RUT si true
 * editableContacto: habilita Email y Teléfono si true
 */
const FormularioRepresentante = ({
  index,
  formData,
  errors,
  onChange,
  editableRutNombre = false,
  editableContacto = false
}) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onChange(index, name, value);
  };

  const handleRutChange = (e) => {
    const { name, value } = e.target;
    const isValid = validarRut(value);
    const formatted = formatearRut(value);
    onChange(index, name, formatted, !isValid && value !== '');
  };

  return (
    <Grid container spacing={1} columns={12}>
      <Grid size={12}>
        <Typography variant="h4" sx={{ fontWeight: '400', pb: 1 }}>
          Datos {index === 0 ? '' : 'otro'} Representante de establecimiento
        </Typography>
      </Grid>

      {/* Nombre */}
      <Grid size={6}>
        <FormControl fullWidth size="small">
          <TextField  test_id={toSnakeCase("nombre_"+index)}
            required
            disabled={!editableRutNombre}
            id={`input-nombre-${index}`}
            label={`Nombres Representante EES ${index + 1}`}
            name="nombre"
            size="small"
            value={formData.nombre}
            onChange={handleInputChange}
          />
        </FormControl>
      </Grid>

      {/* Nombre */}
      <Grid size={6}>
        <FormControl fullWidth size="small">
          <TextField  test_id={toSnakeCase("apellidos_"+index)}
            required
            disabled={!editableRutNombre}
            id={`input-apellido-${index}`}
            label={`Apellidos Representante EES ${index + 1}`}
            name="apellidos"
            size="small"
            value={formData.apellidos}
            onChange={handleInputChange}
          />
        </FormControl>
      </Grid>

      {/* RUT */}
      <Grid size={6}>
        <FormControl fullWidth size="small">
          <TextField  test_id={toSnakeCase("rut_"+index)}
            required
            disabled={!editableRutNombre}
            id={`input-rut-${index}`}
            label={`RUT Representante EES ${index + 1}`}
            name="rut"
            size="small"
            value={formData.rut}
            onChange={handleRutChange}
            error={!!errors.rut}
            helperText={errors.rut ? 'RUT inválido o ya asignado a un representante' : '(12345678-9)'}
          />
        </FormControl>
      </Grid>

      {/* Email */}
      <Grid size={6}>
        <FormControl fullWidth size="small">
          <TextField  test_id={toSnakeCase("email_"+index)}
            required
            disabled={!editableContacto}
            id={`input-email-${index}`}
            label={`Email Representante EES ${index + 1}`}
            name="email"
            size="small"
            value={formData.email}
            onChange={handleInputChange}
            error={!!errors.email}
            helperText={errors.email ? 'Email inválido' : ''}
            type="email"
          />
        </FormControl>
      </Grid>

    </Grid>
  );
};

export default FormularioRepresentante;

